var link_viewer_default = {
  "fontElementMap": "n7kQ8",
  "link": "_4tLcO",
  "linkInEditor": "Z5HiI",
  "linkInViewer": "s6JhR",
  "toolbarUrlContainer": "_5T1pg",
  "toolbarUrl": "WIhUE",
  "toolbarUrlAnchor": "f8wDp"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
